/* LOVE LACE — analytics-ready events.
   Every event is pushed to window.dataLayer (GTM / GA4) and, when available,
   published to Shopify's Customer Events (Shopify.analytics.publish) as
   "ll_<event>" so a Custom Pixel can forward it anywhere.
   No third-party script is loaded here. Nothing is sent unless a tag/pixel
   listens for it.

   Events: section_view · scroll_depth (25/50/75/100) · hero_click ·
   category_click · subcategory_click · style_edit_click · story_click ·
   complete_look_click · product_click · product_view · quick_view ·
   quick_add · add_to_cart · wishlist · filter_apply · sort_change ·
   search · newsletter_signup · begin_checkout · engaged_time (30/60/120/240s) */
(function () {
  'use strict';
  var doc = document, win = window;
  win.dataLayer = win.dataLayer || [];
  var LL = win.LoveLace || {};
  var tpl = LL.template || '';

  function track(name, data) {
    data = data || {};
    data.page_template = tpl;
    try { win.dataLayer.push(Object.assign({ event: 'll_' + name }, data)); } catch (e) {}
    try { if (win.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('ll_' + name, data); } catch (e) {}
  }
  win.LoveLaceTrack = track;

  function text(el) { return (el.getAttribute('data-ll-label') || el.textContent || '').replace(/\s+/g, ' ').trim().slice(0, 80); }
  function sectionOf(el) { var s = el.closest('[data-ll-section]'); return s ? s.getAttribute('data-ll-section') : ''; }

  /* clicks */
  doc.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('a, button');
    if (!t) return;
    var named = t.closest('[data-ll-track]');
    if (named) { track(named.getAttribute('data-ll-track'), { label: text(named), category: named.getAttribute('data-ll-cat') || '', section: sectionOf(named), url: named.getAttribute('href') || '' }); }
    else if (t.closest('.ll-hero')) track('hero_click', { label: text(t), url: t.getAttribute('href') || '' });
    else if (t.closest('.ll-mega, .ll-mnav')) track('category_click', { label: text(t), section: 'navigation', url: t.getAttribute('href') || '' });

    if (t.matches('[data-ll-quick]')) track(t.getAttribute('data-ll-mode') === 'add' ? 'quick_add' : 'quick_view', { url: t.getAttribute('data-ll-quick'), section: sectionOf(t) });
    else if (t.matches('[data-ll-add]')) track('quick_add', { variant_id: t.getAttribute('data-ll-add'), section: sectionOf(t) });
    else if (t.matches('[data-wishlist]')) track('wishlist', { product_id: t.getAttribute('data-product-id') || '', handle: t.getAttribute('data-wishlist-handle') || '', action: t.classList.contains('wishlist-added') ? 'remove' : 'add' });
    else if (t.closest('.ll-card') && t.tagName === 'A') track('product_click', { url: t.getAttribute('href') || '', section: sectionOf(t) });
    if (t.name === 'checkout' || /\/checkout/.test(t.getAttribute('href') || '')) track('begin_checkout', {});
  }, true);

  doc.addEventListener('ll:cart:added', function (e) {
    if (e.detail && e.detail.item) { track('add_to_cart', e.detail.item); return; }
    /* Shopify lists the most recently added line first */
    fetch((LL.routes && LL.routes.cart || '/cart') + '.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) {
      var it = c.items && c.items[0] || {};
      track('add_to_cart', { variant_id: it.variant_id, product_id: it.product_id, title: it.product_title, price: it.final_price, quantity: it.quantity, cart_count: c.item_count, cart_value: c.total_price, currency: c.currency });
    }).catch(function () { track('add_to_cart', {}); });
  });
  doc.addEventListener('ll:filter', function (e) { track(e.detail && e.detail.type === 'sort' ? 'sort_change' : 'filter_apply', e.detail || {}); });

  /* forms: newsletter + search */
  doc.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.querySelector) return;
    if (f.querySelector('[name="contact[email]"]') && /newsletter|customer/.test((f.id || '') + ' ' + (f.className || '') + ' ' + (f.querySelector('[name="form_type"]') || {}).value)) track('newsletter_signup', { section: sectionOf(f) });
    var q = f.querySelector('input[name="q"]');
    if (q && q.value) track('search', { term: q.value.slice(0, 60) });
  }, true);
  var sTimer;
  doc.addEventListener('input', function (e) {
    var i = e.target;
    if (!i || i.name !== 'q' && !(i.closest && i.closest('.df-search, [data-search-input], .search-form'))) return;
    clearTimeout(sTimer);
    sTimer = setTimeout(function () { if (i.value && i.value.length > 2) track('search', { term: i.value.slice(0, 60), type: 'predictive' }); }, 1200);
  }, true);

  /* product view */
  if (LL.product) track('product_view', LL.product);

  /* section views (once each) — every theme section on the page */
  if ('IntersectionObserver' in win) {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (en) {
        if (!en.isIntersecting) return;
        io.unobserve(en.target);
        var inner = en.target.querySelector('[data-ll-section]');
        track('section_view', { section: inner ? inner.getAttribute('data-ll-section') : en.target.id.replace('shopify-section-', '') });
      });
    }, { rootMargin: '-30% 0px -30% 0px' });
    doc.querySelectorAll('#MainContent .shopify-section, main .shopify-section').forEach(function (s) { io.observe(s); });
  }

  /* scroll depth */
  var marks = [25, 50, 75, 100], hit = {}, ticking = false;
  function depth() {
    ticking = false;
    var h = doc.documentElement.scrollHeight - win.innerHeight;
    if (h <= 0) return;
    var pct = (win.scrollY / h) * 100;
    marks.forEach(function (m) { if (pct >= m - 1 && !hit[m]) { hit[m] = 1; track('scroll_depth', { percent: m }); } });
  }
  win.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(depth); } }, { passive: true });

  /* engaged time (only counts while the tab is visible) */
  var secs = 0, steps = [30, 60, 120, 240], sent = {};
  setInterval(function () {
    if (doc.visibilityState !== 'visible') return;
    secs += 5;
    steps.forEach(function (s) { if (secs >= s && !sent[s]) { sent[s] = 1; track('engaged_time', { seconds: s }); } });
  }, 5000);
})();
